import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PayService } from 'src/app/service/pay.service';


function passwordMatchValidator(g: UntypedFormGroup) {
  return g.get('password').value === g.get('confirmPassword').value
    ? null : { 'mismatch': true };
}

@Component({
  selector: 'app-nouveaupartenaire',
  templateUrl: './nouveaupartenaire.component.html',
  styleUrls: ['./nouveaupartenaire.component.css'],
  standalone: false
})
export class NouveaupartenaireComponent implements OnInit {
  PartenaireForm: UntypedFormGroup;
  letterchange: boolean;
  capitalchange: boolean;
  numberchange: boolean;
  lengthchange: boolean;
  symbolechange: boolean;
  isedit: any;
  added: boolean;
  username: string;
  phonexist: boolean;
  validation: boolean;
  emailexist: boolean;
  emailcaissier: any;
  caisierlist: any[];
  partenaireid: any;
  availableEmployeeRoles: { value: string; label: string; }[] = [];

  private readonly defaultEmployeeRoles: { value: string; label: string; }[] = [
    { value: 'MICROFINANCE_CAISSE', label: 'Caissier(ere)' },
    { value: 'MICROFINANCE_COLLECTE', label: 'Collecteur(trice)' },
    { value: 'MICROFINANCE_CREDIT', label: 'Agent de credit' },
  ];

  constructor(private userService: PayService) { }

  ngOnInit(): void {
    this.username = localStorage.getItem('usernameThatUserIsNowConnect2345789');
    this.availableEmployeeRoles = [...this.defaultEmployeeRoles];
    this.ngPartenaireForm();
    this.loadAvailableEmployeeRoles();
    this.afficherLesCaisiers();
  }

  ngPartenaireForm() {
    this.PartenaireForm = new UntypedFormGroup({
      firstName: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
      lastName: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
      email: new UntypedFormControl('', [Validators.required, Validators.pattern("[^ @]*@[^ @]*[.][^ @]{2,}")]),
      employeeRole: new UntypedFormControl('MICROFINANCE_CAISSE', [Validators.required]),
      password: new UntypedFormControl('', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')]),
      confirmPassword: new UntypedFormControl('', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')]),
    }, passwordMatchValidator)
  }

  loadAvailableEmployeeRoles() {
    this.userService.getAvailableEmployeeRoles(this.username).subscribe((roles: string[]) => {
      if (!Array.isArray(roles) || roles.length === 0) {
        this.availableEmployeeRoles = [...this.defaultEmployeeRoles];
        return;
      }

      const mapped = roles.map((role) => ({
        value: role,
        label: this.roleLabel(role),
      }));
      this.availableEmployeeRoles = mapped;
      if (!this.PartenaireForm.get('employeeRole').value) {
        this.PartenaireForm.get('employeeRole').setValue(mapped[0].value);
      }
    }, () => {
      this.availableEmployeeRoles = [...this.defaultEmployeeRoles];
    });
  }

  generateEmail(value) {
    let email = value.replace(/\s/g, "") + "@" + "spay.partenaire.africa";
    this.PartenaireForm.get('email').setValue(email);
    this.PartenaireForm.get('email').statusChanges;
  }

  addCaissier(formdata) {
    if (this.isedit) {
      this.userService.updateNouveauPartenaire(this.username, this.partenaireid, formdata).subscribe(data => {
        if (data == 0) {
          this.added = true;
          this.afficherLesCaisiers();
          setTimeout(() => {
            this.added = false;
          }, 4000);
        }
      })
    }
    else {
      this.userService.ajouterPartenairePartenaire(formdata, this.username).subscribe(data => {
        if (data == 0) {
          this.added = true;
          this.afficherLesCaisiers();
          setTimeout(() => {
            this.added = false;
          }, 4000);
        }
      })
    }

  }


  editer(id, caissier) {
    this.isedit = true;
    this.partenaireid = id;
    this.PartenaireForm.get('firstName').setValue(caissier['firstName']);
    this.PartenaireForm.get('lastName').setValue(caissier['lastName']);
    this.PartenaireForm.get('email').setValue(caissier['username']);
    this.PartenaireForm.get('employeeRole').setValue(this.extractEmployeeRole(caissier));
    this.emailcaissier = caissier['username'];

  }

  afficherLesCaisiers() {
    this.userService.getCaissiersPartenaire(this.username).subscribe((data: any[]) => {
      this.caisierlist = data;

    })
  }


  isEmail(email) {
    console.log(email);
    if (this.emailcaissier == email) {

    }
    else {
      this.userService.findEmail(email).subscribe(res => {
        this.emailexist = !res.success;
        if (this.emailexist) {
          setTimeout(() => {
            this.emailexist = false;
          }, 4000);
        }
      }, err => {
        console.log(err)
      })
    }


  }


  isPhone(phone) {
    this.userService.findPhone(phone).subscribe(res => {
      this.phonexist = !res.success;
    }, err => {

    })

  }
  showvalidationpart() {
    this.validation = true;
  }
  hidevalidationpart() {
    this.validation = false;

  }


  validateValue(textValue) {
    var lowerCaseLetters = /[a-z]/g;
    var myInput = document.getElementById("pass");
    var letter = document.getElementById("letter");
    if (this.PartenaireForm.get('password').value.match(lowerCaseLetters)) {

      this.letterchange = true;
    } else {
      this.letterchange = false;
    }

    var upperCaseLetters = /[A-Z]/g;
    if (this.PartenaireForm.get('password').value.match(upperCaseLetters)) {
      this.capitalchange = true;
    } else {
      this.capitalchange = false;
    }

    // Validate numbers
    var numbers = /[0-9]/g;
    if (this.PartenaireForm.get('password').value.match(numbers)) {
      this.numberchange = true;

    } else {
      this.numberchange = false;
    }

    // Validate length
    if (this.PartenaireForm.get('password').value.length >= 8 && this.PartenaireForm.get('password').value.length < 17) {
      this.lengthchange = true
    } else {
      this.lengthchange = false
    }
    var symbole = /[$@$!%*?&]/g
    if (this.PartenaireForm.get('password').value.match(symbole)) {
      this.symbolechange = true;

    } else {
      this.symbolechange = false;
    }

  }

  get firstName() { return this.PartenaireForm.get('firstName'); }
  get lastName() { return this.PartenaireForm.get('lastName'); }
  get email() { return this.PartenaireForm.get('email'); }
  get employeeRole() { return this.PartenaireForm.get('employeeRole'); }
  get phone() { return this.PartenaireForm.get('phone'); }
  get password() { return this.PartenaireForm.get('password'); }
  get confirmPassword() { return this.PartenaireForm.get('confirmPassword'); }

  roleLabel(role: string): string {
    switch ((role || '').toUpperCase()) {
      case 'MICROFINANCE_CAISSE':
        return 'Caissier(ere)';
      case 'MICROFINANCE_COLLECTE':
        return 'Collecteur(trice)';
      case 'MICROFINANCE_CREDIT':
        return 'Agent de credit';
      default:
        return role || '-';
    }
  }

  extractEmployeeRole(caissier: any): string {
    const roles = Array.isArray(caissier?.roles) ? caissier.roles : [];
    for (const role of roles) {
      const roleName = typeof role === 'string' ? role : role?.roleName;
      const normalized = (roleName || '').toUpperCase();
      if (normalized === 'MICROFINANCE_CAISSE'
        || normalized === 'MICROFINANCE_COLLECTE'
        || normalized === 'MICROFINANCE_CREDIT') {
        return normalized;
      }
    }
    return 'MICROFINANCE_CAISSE';
  }


}
